import { render, staticRenderFns } from "./VendorPercentageInput.vue?vue&type=template&id=401b74b2&scoped=true&"
import script from "./VendorPercentageInput.vue?vue&type=script&lang=js&"
export * from "./VendorPercentageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b74b2",
  null
  
)

export default component.exports